import React, { Component } from 'react';
import {BrowserRouter as Router, Route} from 'react-router-dom'

import './App.css';
import './styles/base-reset.css';
import './styles/base.css';
import './styles/container.css';
import './styles/header.css';
import './styles/content.css';


import Login from './login'
import Forgot from './forgot'
import Verify from './verify'
import Confirm from './confirm'
import Logout from './logout'
import Activation from './activation'
import ResetPassword from './reset-password'
import LargeLoader from './loader'
import Profile from './profile'
const logo = '/logo.svg';

class App extends Component {
  state = {
    loading: true,
    user: null,
    email: null,
    error: null,
    urls: {},
    userHandler: null,
    alertMessage: '',
  };
  setUserHandler = (handler) => {
    this.setState({userHandler: handler})
  };
  clearUser = () => {
    this.setState({user: null})
  };
  setUser = (user) => {
    this.setState({user: user})
  };
  componentDidMount = () => {
    this.setState({loading: false});
    document.getElementById('root').classList.remove('canopy-loader')
  };
  setAlertMessage = (msg, msg_cont, link_text, link_url) => {
    let message = {
      msg: msg,
      msg_cont: msg_cont,
      link_text: link_text,
      link_url: link_url
    };
    this.setState({alertMessage: message})
  };
  render() {
    return (
      <div className="container">
        <div className="header container__header">
          <img src={logo} className="header__logo" alt="logo" />
        </div>
        {this.state.loading ? (
          <div>
						<div className="loginBox">
							<p className="subtitle subtitle-loading">Loading.</p>
						</div>
          </div>
        ) : (
            <div className="content container__content">

              {this.state.alertMessage !== '' ? (
                <div className="warning-notice">
                  <div className="notice-text">
                    <span>{this.state.alertMessage['msg']}</span> {this.state.alertMessage['msg_cont']}
                  </div>
                { this.state.alertMessage['link_text'] !== '' ?
                  (<a href={this.state.alertMessage['link_url']} target="_blank" rel="noopener noreferrer" className="button-text">
                    {this.state.alertMessage['link_text']}
                  </a>) : ''
                }
                  <div className="close" onClick={() => {this.setState({showModal: false})}}>
                    x
                  </div>
                </div>
              ) : ''}

              <Router>
                <div className="content__box">
                  <Route exact path="/" render={routeProps => <Login {...routeProps} setUser={this.setUser} setUserHandler={this.setUserHandler}/>}/>
                  <Route path="/login" render={routeProps => <Login {...routeProps} setUser={this.setUser} setUserHandler={this.setUserHandler}/>}/>
                  <Route path="/logout" render={routeProps => <Logout {...routeProps} clearUser={this.clearUser}/>}/>
                  <Route path="/set-password" render={routeProps => <ResetPassword {...routeProps}/>}/>
                  <Route path="/forgot" component={Forgot}/>


                  <Route path="/activate" render={routeProps => <Activation {...routeProps}/>}/>

                  <Route path="/profile" render={routeProps => <Profile {...routeProps}/>}/>
                  <Route path="/settings" render={routeProps => <Profile {...routeProps}/>}/>

                  <Route path="/verify" render={routeProps => <Verify {...routeProps} setAlert={this.setAlertMessage}/>}/>
                  <Route path="/reset-confirm" component={Confirm}/>
                  <Route path="/loader" component={LargeLoader}/>
                </div>
              </Router>

            </div>
        )}
        <div className="row footer">&nbsp;</div>
      </div>
  )}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js